import markdown from 'markdown-it';

const md = markdown('zero', { breaks: true });

md.enable('hr');
md.enable('paragraph');
md.enable('newline');
md.enable('heading');
md.enable('lheading');
md.enable('list');
md.enable('blockquote');
md.enable('emphasis');
md.enable('image');

/**
 * Render a Markdown string to a HTML string
 *
 * @example
 * renderMarkdown('# Header *bold*');
 * // Result: '<h1>Header <b>bold</b></h1>'
 */
export function renderMarkdown(str: string): string {
  return md.render(str);
}

/**
 * Get the text content of a Markdown string once rendered to HTML.
 *
 * @example
 * renderMarkdown('# Header *bold*');
 * // Result: '<h1>Header <b>bold</b></h1>'
 * getMarkdownTextContent('# Header *bold*');
 * // Result: 'Header bold'
 */
export function getMarkdownTextContent(str: string): string {
  const bodyHTML = renderMarkdown(str);
  const element = document.createElement('span');
  element.innerHTML = bodyHTML;
  const text = element.textContent || '';
  element.remove();
  return text;
}
